// A window (modal) must not close when you select text inside it and let go of
// the mouse over the dark backdrop (Stephanie 2026-10-27: "when im selecting
// text and move the mouse too far to the left, it backs me out of what i was
// doing"). The browser sends that drag as a click on the backdrop — the common
// parent of where the press started and where it ended — and every window
// closes on a backdrop click. One document-level guard for all of them: a click
// whose press started INSIDE something else and lands on a full-screen overlay
// is swallowed. A real click on the backdrop (pressed and released there)
// still closes the window; nothing else is touched.

import { isDragOutClick, isFullScreenOverlay } from "@merchd/shared";

export function keepWindowsOpenOnDragOut(doc: Document): void {
  let pressTarget: Node | null = null;
  doc.addEventListener("mousedown", (e) => {
    pressTarget = e.target instanceof Node ? e.target : null;
  }, true);
  doc.addEventListener("click", (e) => {
    const t = e.target;
    if (!(t instanceof HTMLElement)) return;
    const overlay = isFullScreenOverlay(
      getComputedStyle(t),
      t.getBoundingClientRect(),
      { width: window.innerWidth, height: window.innerHeight },
    );
    if (isDragOutClick(pressTarget, t, overlay)) {
      e.stopPropagation();
      e.preventDefault();
    }
  }, true);
}
